import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type StoreBaseReturn } from '@shared/api';

interface UseRejectApplication2Store {
  loading: boolean;
  data: boolean;
  error: string | null;
  rejectApplication: (applicationId: string, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useRejectApplication2Store = create<UseRejectApplication2Store>((set) => ({
  loading: false,
  data: false,
  error: null,

  rejectApplication: async (applicationId, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await ApplicationApi.rejectApplication(applicationId, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
